module.exports = __webpack_public_path__ + "static/media/reacteurope.7dc0c74f.svg";